import { render, staticRenderFns } from "./slides.vue?vue&type=template&id=f9288ec2"
import script from "./slides.vue?vue&type=script&lang=ts"
export * from "./slides.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports